<div (click)="$event.preventDefault(); closeModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4">
    <div class="w-full max-w-screen-md max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full max-h-full bg-white p-10 rounded-md text-center shadow-lg">
            <form (ngSubmit)="$event.preventDefault(); saveNew();" #activityForm="ngForm"
                class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2
                        class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        Add a New Material
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>

                <div class="w-full h-full overflow-y-auto flex flex-col items-center justify-start gap-2 px-1 pb-4 border-b border-gray-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Event Name:</p>
                        </div>
                        <div class="relative flex-grow h-full flex flex-col items-center">
                            <input type="text" name="activity" [(ngModel)]="activity.activity_name" required noEmoji
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Create new activity">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="activityForm.submitted && !activity.activity_name">
                                This field is required.
                            </div>
                        </div>
                    </div>
                    <!-- Full detail set: AL only. MS collects event name + courses of action. -->
                    <ng-container *ngIf="showFullDetails">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Location:</p>
                        </div>
                        <div class="relative flex-grow h-full flex flex-col items-center">
                            <input type="text" name="location" [(ngModel)]="activity.location" required noEmoji
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Location">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="activityForm.submitted && !activity.location">
                                This field is required.
                            </div>
                        </div>
                    </div>
                    
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Primary Contact:</p>
                        </div>
                        <div class="flex-grow flex flex-col items-center">
                            <select 
                              name="contact_id"
                              [(ngModel)]="activity.primary_contact_id"
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                                <option *ngFor="let contact of contactsList" [value]="contact.id">
                                    {{ contact.name }} - {{ contact.email }}
                                </option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Secondary Contact:</p>
                        </div>
                        <div class="flex-grow flex flex-col items-center">
                            <select 
                              name="contact_id"
                              [(ngModel)]="activity.secondary_contact_id"
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                                <option *ngFor="let contact of contactsList" [value]="contact.id">
                                    {{ contact.name }} - {{ contact.email }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Emergency Equipment:</p>
                        </div>
                        <div class="relative flex-grow h-full flex flex-col items-center">
                            <input type="text" name="activity" [(ngModel)]="activity.emergency_equipment" required noEmoji
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Create new activity"
                                (focus)="showSuggestions = true"
                                (blur)="hideSuggestions()">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="activityForm.submitted && !activity.emergency_equipment">
                                This field is required.
                            </div>

                            <div *ngIf="showSuggestions && filteredSuggestions.length > 0"
                            class="absolute top-full left-0 mt-1 z-20 divide-y divide-gray-300 bg-white rounded-md w-full shadow-md max-h-48 overflow-y-auto">
                                <ul class="p-2">
                                    <li 
                                        *ngFor="let suggestion of filteredSuggestions" 
                                        (mousedown)="selectSuggestion(suggestion)"
                                        class="px-3 py-2 cursor-pointer hover:bg-gray-100"
                                    >
                                        {{ suggestion }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- FIRST AID CONTACTS -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>First Aid:</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #firstAidSelect
                                    name="first_aid_contact_id"
                                    (change)="addContact('first_aid', firstAidSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.first_aid.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.first_aid; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('first_aid', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <!-- CPR CONTACTS -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>CPR:</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #cprSelect
                                    name="cpr_contact_id"
                                    (change)="addContact('cpr', cprSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.cpr.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.cpr; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('cpr', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- AED -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>AED:</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #aedSelect
                                    name="aed_contact_id"
                                    (change)="addContact('aed', aedSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.aed.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.aed; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('aed', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Incident Response Procedures -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>Incident Response Procedures:</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #incidentReportingSelect
                                    name="incident_reporting_contact_id"
                                    (change)="addContact('incident_reporting', incidentReportingSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.incident_reporting.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.incident_reporting; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('incident_reporting', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>
  
                    <!-- Individual Emergency Action Plans (IEAP) -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>Individual Emergency Action Plans (IEAP):</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #ieapSelect
                                    name="ieap_contact_id"
                                    (change)="addContact('ieap', ieapSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.ieap.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.ieap; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('ieap', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Emergency Diabetic Medications: -->
                    <div class="w-full flex flex-col text-start gap-2">
                        <div class="w-full flex items-center text-start">
                            <div class="w-44 flex items-center text-nside-gray-300">
                                <p>Emergency Diabetic Medications:</p>
                            </div>
                            <div class="flex-grow flex flex-col items-center">
                                <select
                                    #emergencyDiabeticSelect
                                    name="emergency_diabetic_contact_id"
                                    (change)="addContact('emergency_diabetic', emergencyDiabeticSelect.value)"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                >
                                    <option value="">Select a contact...</option>
                                    <option *ngFor="let contact of contactsList" [value]="contact.id">
                                        {{ contact.name }} - {{ contact.email }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    
                        <div *ngIf="selectedContacts.emergency_diabetic.length > 0" class="flex flex-wrap gap-2 pl-44">
                            <div
                                *ngFor="let contact of selectedContacts.emergency_diabetic; let i = index"
                                class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1"
                            >
                                {{ contact.name }}
                                <button type="button" (click)="$event.preventDefault(); removeContact('emergency_diabetic', i)" class="ml-1">
                                    <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    </ng-container>
                    
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Courses of Action:</p>
                        </div>
                        <div class="relative flex-grow h-full flex flex-col items-center">
                            <textarea type="text" name="location" [(ngModel)]="activity.courses_of_action" required noEmoji
                            rows="8" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder=""></textarea>
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="activityForm.submitted && !activity.courses_of_action">
                                This field is required.
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Buttons -->
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isValidActivity(),
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isValidActivity()
                        }"
                        [disabled]="!isValidActivity()"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>